import { IS_WEB, isClient, safeJsonParse } from "./common";

type TStorageValue = string | number | boolean | object;
/**
 * 将数据以 JSON 字符串形式保存到本地存储（localStorage 或 sessionStorage）。
 * 仅适用于 Web 端。
 *
 * @template T - 可序列化的数据类型
 * @param {string} key - 存储的键名
 * @param {T} data - 要保存的数据，支持 string、number、boolean、object
 * @param {boolean} [persistent=true] - 是否持久化存储（true: localStorage，false: sessionStorage）
 *
 */
export const saveData = <T extends TStorageValue>(key: string, data: T, persistent?: boolean) => {
  if (!isClient) return;
  try {
    const _cacheData = JSON.stringify(data);
    const isPersistent = persistent ?? true;
    if (isPersistent) {
      window.localStorage.setItem(key, _cacheData);
    } else {
      window.sessionStorage.setItem(key, _cacheData);
    }
  } catch (err) {
    console.error("[saveData error]：", err);
  }
};

export const removeItem = (key: string) => {
  if (!isClient) return;
  try {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  } catch (err) {
    console.error("[removeItem error]：", err);
  }
};
export const loadData = <T>(key: string) => {
  if (!IS_WEB) return;
  try {
    const _loadData = window.localStorage.getItem(key) ?? window.sessionStorage.getItem(key);
    return _loadData ? safeJsonParse<T>(_loadData) : undefined;
  } catch (err) {
    console.error("[loadData error]：", err);
    return undefined;
  }
};
